import { Box, Button, Paper, Stack, Typography } from "@mui/material";

interface SmartAction {
  label: string;
  sublabel: string;
  value: string;
  done: boolean;
}

const smartActions: SmartAction[] = [
  { label: "Client Information", sublabel: "All fields completed", value: "4/4", done: true },
  { label: "Introduction Letter", sublabel: "Ready", value: "1/1", done: true },
  { label: "Package", sublabel: "Not yet selected", value: "1/1", done: true },
  { label: "Addition Services", sublabel: "Not yet selected", value: "4/4", done: true },
  { label: "Stream Thumbnail", sublabel: "Not yet selected", value: "4/4", done: true },
];

interface SmartActionsSidebarProps {
  onSave?: () => void;
  onSendToClient?: () => void;
  onFinishLater?: () => void;
  isUpdate?: boolean;
  isSaving?: boolean;
}

export default function SmartActionsSidebar({
  onSave,
  onSendToClient,
  onFinishLater,
  isUpdate = false,
  isSaving = false,
}: SmartActionsSidebarProps) {
  return (
    <Box sx={{ width: 260, flexShrink: 0 }}>
      <Paper sx={{ borderRadius: "14px", p: 2, boxShadow: 0, mb: 2 }}>
        <Typography
          sx={{ fontWeight: 700, fontSize: "14px", color: "#1e293b", mb: 1.5 }}
        >
          Smart Actions
        </Typography>
        <Stack spacing={1}>
          {smartActions.map((action, index) => (
            <Stack
              key={index}
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              sx={{ bgcolor: "#f0fdf4", borderRadius: "8px", px: 1, py: 0.8 }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                <Box
                  sx={{
                    width: 20,
                    height: 20,
                    borderRadius: "50%",
                    bgcolor: "#16a34a",
                    flexShrink: 0,
                  }}
                />
                <Box>
                  <Typography
                    sx={{ fontSize: "11px", fontWeight: 600, color: "#16a34a" }}
                  >
                    {action.label}
                  </Typography>
                  <Typography sx={{ fontSize: "10px", color: "#94a3b8" }}>
                    {action.sublabel}
                  </Typography>
                </Box>
              </Stack>
              <Typography
                sx={{ fontSize: "11px", fontWeight: 700, color: "#475569" }}
              >
                {action.value}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Paper>

      {/* Action buttons */}
      <Stack spacing={1.5}>
        <Button
          onClick={onSave}
          fullWidth
          disabled={isSaving}
          sx={{
            bgcolor: "#724e41",
            color: "white",
            borderRadius: "12px",
            py: 1.5,
            textTransform: "none",
            fontWeight: 700,
            fontSize: "14px",
            "&:hover": { bgcolor: "#5d3e33" },
          }}
        >
          {isSaving ? "Saving..." : isUpdate ? "Update & View" : "Save & View"}
        </Button>
        <Button
          onClick={onSendToClient}
          fullWidth
          sx={{
            bgcolor: "#c59a70",
            color: "white",
            borderRadius: "12px",
            py: 1.5,
            textTransform: "none",
            fontWeight: 700,
            fontSize: "14px",
            "&:hover": { bgcolor: "#b08960" },
          }}
        >
          Send to Client
        </Button>
        <Button
          onClick={onFinishLater}
          fullWidth
          sx={{
            bgcolor: "#ffffff",
            color: "#64748b",
            borderRadius: "12px",
            py: 1.5,
            textTransform: "none",
            fontWeight: 600,
            fontSize: "14px",
            "&:hover": { bgcolor: "#f8fafc" },
          }}
        >
          Finish Later
        </Button>
      </Stack>
    </Box>
  );
}